'use client';
import Image from 'next/image';
import { Star, BadgeCheck, Quote } from 'lucide-react';
import styles from './Testimonials.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

const TESTIMONIALS = [
  {
    name: "Roger Chagas",
    role: "CEO, Grupo Digital",
    quote: "A modularidade do Aesir mudou nosso jogo. Começamos só com o PDV e o Financeiro. Quando ativamos o módulo de campanhas de WhatsApp integrado ao sistema, nossas vendas triplicaram sem risco de banimento.",
    avatar: "/assets/images/dep1.png"
  },
  {
    name: "Diego Maia",
    role: "Diretor, RMaia Soluções",
    quote: "O que mais impressiona é o design. Migramos de um sistema cinza e complexo dos anos 2000 para o Aesir. A equipe aprendeu a usar o Chat Omnichannel em menos de 2 horas. Atendimento e OS agora andam juntos.",
    avatar: "/assets/images/dep2.png"
  },
  {
    name: "Rafael Bachega",
    role: "CEO, Grupo Safira",
    quote: "Ter a IA qualificando nossos leads de Instagram e já enviando o link de pagamento do PDV direto no WhatsApp salvou o nosso faturamento aos finais de semana. O sistema se paga nos primeiros dias do mês.",
    avatar: "/assets/images/dep3.png"
  }
];

export function Testimonials() {
  return (
    <section id="depoimentos" className={styles.section}>
      <div className={styles.container}>
        
        <ScrollAnimator>
          <div className={styles.header}>
            <h2>Quem usa, recomenda</h2>
            <p>Empresas de todos os tamanhos estão escalando suas operações com o Aesir ERP.</p>
          </div>
        </ScrollAnimator>

        <div className={styles.grid}>
          {TESTIMONIALS.map((testimonial, i) => (
            <ScrollAnimator key={i} delay={i * 150}>
              <div className={styles.card}>
                
                {/* Marca d'água Gigante */}
                <Quote size={120} className={styles.quoteWatermark} />

                <div className={styles.content}>
                  {/* Estrelinhas */}
                  <div className={styles.stars}>
                    <Star size={18} fill="currentColor" />
                    <Star size={18} fill="currentColor" />
                    <Star size={18} fill="currentColor" />
                    <Star size={18} fill="currentColor" />
                    <Star size={18} fill="currentColor" />
                  </div>
                  
                  {/* Texto do Depoimento */}
                  <p className={styles.quoteText}>"{testimonial.quote}"</p>
                </div>

                {/* Rodapé do Card */}
                <div className={styles.author}>
                  {/* NOTA: Se as imagens dep1.png não existirem no seu projeto, você pode colocar imagens genéricas ou remover a tag Image */}
                  <Image 
                    src={testimonial.avatar} 
                    alt={testimonial.name} 
                    width={50} 
                    height={50} 
                    className={styles.avatar}
                  />
                  <div className={styles.authorInfo}>
                    <span className={styles.authorName} title="Cliente Verificado">
                      {testimonial.name}
                      <BadgeCheck size={16} color="#10b981" />
                    </span>
                    <span className={styles.authorRole}>{testimonial.role}</span>
                  </div>
                </div>

              </div>
            </ScrollAnimator>
          ))}
        </div>

        {/* Rodapé de Confiança */}
        <ScrollAnimator delay={500}>
          <div className={styles.trustFooter}>
            <div className={styles.avatarsGroup}>
              <img src="/assets/images/dep1.png" alt="User" />
              <img src="/assets/images/dep2.png" alt="User" />
              <img src="/assets/images/dep3.png" alt="User" />
            </div>
            <p>Junte-se a dezenas de empresas inovadoras.</p>
          </div>
        </ScrollAnimator>

      </div>
    </section>
  );
}